export interface MockOffering {
  id: string;
  name: string;
  slug: string;
  tagline: string;
  description: string;
  category: string;
  heroImageUrl: string;
  active: boolean;
  sortOrder: number;
  durationMinutes?: number | null;
  audienceRange?: string | null;
  includes?: string[];
}

export const MOCK_OFFERINGS: MockOffering[] = [
  {
    id: 'mock-1',
    name: 'Jurassic Jeep Experience',
    slug: 'jurassic-jeep',
    tagline: 'The iconic roaming Jeep that turns heads everywhere',
    description: 'Our custom-built Jurassic Jeep patrols your event grounds with roaring sound effects, fog machines, and a costumed ranger at the wheel. Perfect as a roaming centrepiece that draws crowds from every corner of your venue.',
    category: 'ACTIVATION',
    heroImageUrl: '/images/jurassic-jack-jeep-performance-038.jpeg',
    active: true,
    sortOrder: 1,
  },
  {
    id: 'mock-2',
    name: 'Dinosaur Encounter Show',
    slug: 'dino-encounter',
    tagline: 'Live performance with life-size dinosaur puppets',
    description: 'A high-energy 30-minute live show featuring life-size animatronic dinosaurs, audience interaction, comedy, and educational content. Suitable for crowds of 50 to 5,000+ and adaptable to any stage or open area.',
    category: 'ACTIVATION',
    heroImageUrl: '/images/jurassic-jack-dinosaur-performance-013.jpeg',
    active: true,
    sortOrder: 2,
  },
  {
    id: 'mock-3',
    name: 'Roaming Dinosaurs',
    slug: 'roaming-dinos',
    tagline: 'Surprise encounters throughout your event',
    description: 'Our performers in realistic dinosaur costumes roam freely through your event, creating spontaneous photo opportunities and delighting guests of all ages. Includes T-Rex, Velociraptor, and baby dino characters.',
    category: 'ROAMING',
    heroImageUrl: '/images/jurassic-jack-dinosaur-party-event-020.jpeg',
    active: true,
    sortOrder: 3,
  },
  {
    id: 'mock-4',
    name: 'Fossil Dig Zone',
    slug: 'fossil-dig',
    tagline: 'Hands-on paleontology for budding scientists',
    description: 'A supervised excavation zone where kids dig for replica fossils, bones, and amber specimens buried in sand. Each child receives a discovery certificate and a fossil to take home. Great for school events and festivals.',
    category: 'ACTIVATION',
    heroImageUrl: '/images/jurassic-jack-dino-experience-009.jpeg',
    active: true,
    sortOrder: 4,
  },
  {
    id: 'mock-5',
    name: 'Dinosaur Detectives',
    slug: 'dino-detectives',
    tagline: 'Interactive mystery-solving adventure',
    description: 'An educational program where children become Dinosaur Detectives, solving clues, examining specimens, and learning about prehistoric life. Aligned with the Victorian science curriculum for school incursions.',
    category: 'ACTIVATION',
    heroImageUrl: '/images/dinosaur-detectives-hat-book-010.jpeg',
    active: true,
    sortOrder: 5,
  },
  {
    id: 'mock-6',
    name: 'Dino Museum Display',
    slug: 'dino-museum',
    tagline: 'Portable museum of prehistoric wonders',
    description: 'A curated collection of replica fossils, dinosaur skulls, amber specimens, and educational displays. Self-contained setup that works indoors or outdoors. Perfect for libraries, museums, and school halls.',
    category: 'ADD_ON',
    heroImageUrl: '/images/jurassic-jack-dino-displays-016.jpeg',
    active: true,
    sortOrder: 6,
  },
  {
    id: 'mock-7',
    name: 'Baby Dino Nursery',
    slug: 'baby-dino-nursery',
    tagline: 'Meet and hold adorable baby dinosaurs',
    description: 'A gentle, interactive experience where children can meet, hold, and feed realistic baby dinosaur puppets. Specially designed for younger audiences at kinders, libraries, and family events.',
    category: 'ADD_ON',
    heroImageUrl: '/images/happy-child-dinosaur-mask-021.jpeg',
    active: true,
    sortOrder: 7,
  },
  {
    id: 'mock-8',
    name: 'Jurassic Jack Full-Day Package',
    slug: 'full-day-package',
    tagline: 'The complete prehistoric experience — all day',
    description: 'Our premium package combines the Jurassic Jeep, roaming dinosaurs, fossil dig zone, museum display, and a live show into one epic full-day activation. Ideal for ag shows, major festivals, and large-scale events.',
    category: 'ACTIVATION',
    heroImageUrl: '/images/jurassic-jack-dino-adventure-045.png',
    active: true,
    sortOrder: 8,
  },
  {
    id: 'mock-9',
    name: 'Dino Photo Booth',
    slug: 'dino-photo-booth',
    tagline: 'Prehistoric photo ops your guests will share',
    description: 'A themed photo area with dinosaur props, jungle backdrop, and Jurassic Jack branding. Guests snap photos with life-size dino cutouts and props. Digital copies available via QR code.',
    category: 'ADD_ON',
    heroImageUrl: '/images/jurassic-jack-performance-fun-026.jpeg',
    active: true,
    sortOrder: 9,
  },
];
